import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { channelBuyQuery, mobileBrandQuery } from '../../../services/react-query/optionMasterQuery';
import { useInsertWarranty } from './useInsertWarranty';
import { useGetRegisterList } from '../../registration/hooks/useGetRegisterList';
import { handleSubmitForm } from '../function/submitHandler';

export const useGetRegProductList = (warrantyNumberCodeInput) => {
  const profile = useSelector((state) => state.info) || null;
  const registerProductData = useSelector((state) => state.registerProduct);
  const fullName = profile ? profile.fullName : '-';
  const telephone = profile ? profile.telephone : '-';
  const warrantyNumberCode = registerProductData?.warrantyNumberCode || warrantyNumberCodeInput || null;

  const { getValues, setValue, control, handleSubmit } = useForm({
    defaultValues: {
      fullName: '',
      telephone: '',
      barcodeShortcut: '',
      productTypeName: '',
      warrantyNumberCode: warrantyNumberCode,
    },
  });
  const { isLoadingBarcode } = useGetRegisterList();
  const { data: mobileBrandList } = mobileBrandQuery();
  const { data: channelBuyList } = channelBuyQuery();
  const { mutate: onInsertWarranty } = useInsertWarranty();

  useEffect(() => {
    setValue('fullName', fullName);
    setValue('telephone', telephone);
  }, [fullName, telephone, setValue]);

  const onSubmit = async (values) => {
    try {
      const data = { ...values, warrantyNumberCode };
      await handleSubmitForm(data, onInsertWarranty);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return {
    getValues,
    setValue,
    control,
    mobileBrandList,
    channelBuyList,
    onSubmit,
    handleSubmit,
    isLoadingBarcode,
  };
};
